var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:({ color: _vm.value === _vm.reveal.name ? _vm.reveal.color : 'black' })},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }